import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import type { I18nTranslateOptions } from '@recruitee/i18n';
import { I18nService } from '@recruitee/i18n';

import type { DropdownItem } from '../../dropdown-scrollable/dropdown-scrollable.component';

@Pipe({
  name: 'rtTranslateDropdownItems',
  standalone: true,
})
export class TranslateDropdownItemsPipe implements PipeTransform {
  constructor(private i18n: I18nService) {}
  public transform(
    items: DropdownItem[],
    translateOptions: Record<DropdownItem['value'], I18nTranslateOptions | any> = {},
  ): DropdownItem[] {
    return items.map(item => ({
      ...item,
      option: this.i18n.translate(item.option, translateOptions[item.value]),
    }));
  }
}
